import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import moment from "moment";
import { Banner, BannerTitle } from "./Banner";
import CustomModal from "./CustomModal";
import { postApiCall } from "../service/PostApiCall";
import { USER_MY_BIRTHDAY_WISH } from "../service/apiUrl";

/* ============================================================================
   "Happy Birthday, <name>" — a slim dark strip at the top of the shell's
   panel, on every page, all day, for the person whose birthday it is.

   The wish comes from /user-api/my-birthday-wish. The backend picks it from
   the admin-managed pool (Workplace › Birthday Wishes) once per person per
   day, so it survives refreshes and other browsers, and the dashboards show
   the same text under "Today is <name>'s Birthday!". The strip shows the
   start of it; clicking opens the whole wish. ✕ hides the strip for the rest
   of the day on this browser (`birthdayStripHidden` = "<uid>|<date>").
   ========================================================================== */
const HIDDEN_KEY = "birthdayStripHidden";

const CakeGlyph = () => (
  <span className="birthday-strip-glyph" aria-hidden="true">🎂</span>
);

const BirthdayStrip = () => {
  const user = useSelector((state) => state.signinReducers)?.data;
  const today = moment().format("YYYY-MM-DD");
  const hiddenMark = `${user?.id}|${today}`;
  const isBirthday =
    Boolean(user?.dob) && moment(user.dob, "YYYY-MM-DD").format("MM-DD") === today.slice(5);

  const [wish, setWish] = useState(null);
  const [hidden, setHidden] = useState(() => localStorage.getItem(HIDDEN_KEY) === hiddenMark);
  const [reading, setReading] = useState(false);

  useEffect(() => {
    if (!isBirthday || !user?.access_token) return;
    postApiCall({}, user.access_token, USER_MY_BIRTHDAY_WISH)
      .then((data) => setWish(data?.wish || null))
      .catch((error) => console.error("BIRTHDAY_STRIP", error));
  }, [isBirthday, user?.access_token]);

  const hide = () => {
    localStorage.setItem(HIDDEN_KEY, hiddenMark);
    setHidden(true);
  };

  const firstName = user?.first_name ?? "";

  return (
    <>
      <Banner
        open={Boolean(wish) && !hidden}
        icon={CakeGlyph}
        dismissible
        onDismiss={hide}
        className="app-banner birthday-strip"
      >
        <BannerTitle>
          <button
            type="button"
            className="birthday-strip-open"
            onClick={() => setReading(true)}
          >
            <span className="birthday-strip-name">Happy Birthday, {firstName}</span>
            <span className="birthday-strip-text">{wish}</span>
          </button>
        </BannerTitle>
      </Banner>

      <CustomModal
        isShow={reading}
        onHide={() => setReading(false)}
        heading={`Happy Birthday, ${firstName} 🎂`}
        footer={
          <button
            type="button"
            className="app-dialog-btn app-dialog-btn-primary"
            onClick={() => setReading(false)}
          >
            Thank you
          </button>
        }
      >
        <blockquote className="birthday-wish-quote">{wish}</blockquote>
        <p className="birthday-wish-sign">With warm wishes from everyone at RapidSofts</p>
      </CustomModal>
    </>
  );
};

export default BirthdayStrip;
